import { setConfig } from '../config'
import { useLocalisation } from '@/tools/i18n/client'

export const InitPintxo = () => {
  const { t } = useLocalisation()
  setConfig(t)
  return null
}
